import React from 'react'
import { AppBar, Toolbar, Box, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'

const StyledButton = styled(Button)`
  && {
    color: #000;
    :hover {
      color: #0c479d;
    }
  }
`

export const Navbar = () => {
  const { pathname } = useLocation()

  const isTngCampaign = ['/nexentireregister', '/nexentiretngcampaign'].includes(pathname)

  return (
    <>
      <AppBar sx={{ color: '#FFFFFF', backgroundColor: '#fff' }}>
        <Toolbar>
          <Box display='flex' justifyContent='center' width='100%'>
            <Box display='flex' align='center'>
              <Link to={isTngCampaign ? '/nexentiretngcampaign' : '/'}>
                <Box pr={1}>
                  <img
                    src={require('../assets/Hoof-header.png')}
                    width={280}
                    height={40}
                    priority='true'
                  />
                </Box>
              </Link>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  )
}
